<div #container class="flex-grow-1 border rounded-lg ai-chat position-relative">
    @if (isLoading()) {
        <div class="loading-icon position-absolute w-100 h-100"></div>
    } @else {
        <!-- Instruction card -->
        @if (messages().length === 0) {
            <div class="card m-1">
                <div class="card-body py-2">
                    <div class="ai-disclosure font-weight-bold small mb-2">
                        {{ 'aiReport.lbl_ai_disclosure' | translate }}
                    </div>
                    <div class="font-weight-bold small mb-1">
                        {{ 'aiReport.lbl_welcome' | translate }}
                    </div>
                    <ul class="pl-3 mb-2 small">
                        <li> {{ 'aiReport.lbl_instruction_1' | translate }}</li>
                        <li>{{ 'aiReport.lbl_instruction_2' | translate }}</li>
                        <li>{{ 'aiReport.lbl_instruction_3' | translate }}</li>
                    </ul>
                    <div class="text-muted small">{{ 'aiReport.lbl_instruction_4' | translate }}</div>
                </div>
            </div>
        }

        <div class="chat-container px-2 pt-2">
            @for (m of visibleMessages(); track m.id ?? $index) {
                <app-chat-message-bubble
                  [message]="m"
                  (retryClicked)="onRetry()"
                />
            }

            @for (group of assetsByTurn(); track group.turn) {
                <div class="text-muted small mt-2">{{ 'aiReport.lbl_assets_from_turn' | translate: { turn: group.turn } }}</div>
                @for (id of group.assetIds; track id) {
                    @if (id | assetMeta | async; as asset) {
                        @if (asset.type === 'base64' || asset.type === 'svg-source') {
                            <app-asset [asset]="asset" mode="view" class="mt-2 d-block" />
                        }
                    }
                }
            }
        </div>
    }
    <!-- Suggestions -->
    <app-chat-suggestions />
</div>
